<template>
  <div>
    <div class="gallery row m-0 w-100">
      <div class="btn p-1 shadow-none" v-for="photo in configuration.photos" :key="'photo_' + photo.id" :href="photo.file">
        <a :href="photo.file">
          <img :src="photo.thumb">
        </a>
        <button v-if="isLoggedIn" type="button" class="btn btn-danger shadow-none photo-remove w-100" @click="photoDelete(photo)">удалить</button>
      </div>
    </div>
    <FilePond class="m-1" v-if="isLoggedIn" 
      name="file"
      ref="pond"
      accepted-file-types="image/jpeg, image/png"
      label-idle="Добавить фото. Нажмите или перетащите их в это поле"
      allow-multiple="true"
      max-files="5"
      :server="server"
      @processfile="processfile"
      @removefile="removefile(false)"/>
    <div class="gallery row m-0 w-100">
      <div class="col-12 col-sm-6 p-1 mt-2" v-for="video in configuration.videos" :key="'video' + video.id">
        <div v-html="changeHtml(video.url)"/>
        <button v-if="isLoggedIn" type="button" class="btn btn-danger shadow-none photo-remove w-100" @click="videoDelete(video)">удалить</button>
      </div>
    </div>
    <button v-if="isLoggedIn" type="button" class="btn btn-outline-primary shadow-none mt-2 w-100" data-toggle="modal" data-target="#videoModal" @click.prevent="url = '', error = ''">добавить видео</button>

    <div class="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Добавить видео</h5>
            <button ref="closeVideoModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form enctype="multipart/form-data" action="#">
              <div class="form-group row ml-0 mr-2 mb-1 mt-1">
                <label class="col-2 text-right" for="url">HTML IFRAME</label>
                <textarea class="col-10 form-control" rows=6 id="url" v-model="url" required></textarea>
              </div>
            </form>
            <div v-if="error.length > 0" class="alert alert-danger" role="alert">{{ error }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Отмена</button>
            <button type="button" class="btn btn-outline-primary" @click="saveVideo">Добавить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import "magnific-popup";
import 'magnific-popup/dist/magnific-popup.css';
import 'filepond/dist/filepond.min.css';
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType);
export default {
  name: "Gallery",
  props: {
    configuration: Object,
  },
  data() {
    return {
      server: {
        process: {
          url: axios.defaults.baseURL + '/photos',
          revert: null,
          method: 'POST',
          withCredentials: false,
          timeout: 10000,
          onload: null,
          onerror: null,
          ondata: (formData) => {
            formData.append('configuration', this.configuration.id);
            return formData;
          },
        },
      },
      url: '',
      error: '',
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn();
    },
  },
  methods: {
    processfile(error, file) {
      this.configuration.photos.push(JSON.parse(file.serverId));
      this.$refs.pond.removeFiles(file);
    },
    removefile(error, file, manual=false) {
      if (manual) {
        var f = JSON.parse(file.serverId);
        var ind = -1;
        axios.delete(`/photos/${f.id}`)
          .then(() => {
            for (var i = 0; i < this.configuration.photos.length; i++)
              if (this.configuration.photos[i].id == f.id)
                ind = i
            this.configuration.photos.splice(ind, 1);
          });
      }
    },
    photoDelete(photo) {
      var ind = -1;
      axios.delete(`/photos/${photo.id}`)
        .then(() => {
          for (var i = 0; i < this.configuration.photos.length; i++)
            if (this.configuration.photos[i].id == photo.id)
              ind = i;
          this.configuration.photos.splice(ind, 1);
        });
    },
    saveVideo() {
      this.error = '';
      var form_data = new FormData();
      form_data.append('url', this.url);
      form_data.append('configuration', this.configuration.id);
      axios.post('videos', form_data, {headers: {'Content-Type': 'multipart/form-data'}}).then((resp) => {
        this.configuration.videos.push(resp.data);
        this.$refs.closeVideoModal.click();
      }).catch(() => {
        this.error = 'URL должен быть заполнен';
      });
    },
    videoDelete(video) {
      var ind = -1;
      axios.delete(`/videos/${video.id}`)
        .then(() => {
          for (var i = 0; i < this.configuration.videos.length; i++)
            if (this.configuration.videos[i].id == video.id)
              ind = i;
          this.configuration.videos.splice(ind, 1);
        });
    },
    changeHtml(html) {
      html = html.replace('width', 'w');
      html = html.replace('height', 'h');
      return html.replace('<iframe', '<iframe width="100%"');
    },
  },
  mounted() {
    $('.gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true,
      },
    });
  },
  components: {
    FilePond,
  },
}
</script>

<style scoped>
img {
  height: 100px;
  width: 100px;
  -o-object-fit: cover;
  object-fit: cover;
  overflow: hidden;
}
.gallery a {
  display: inline-block;
}
.photo-remove {
  display: block;
}
</style>
